module.exports = __webpack_public_path__ + "img/userbase2.422c672f.png";